import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../Views/Login";
import Layout from "../Components/Organisms/Layout";
import Dashboard from "../Views/Dashboard";
import Employees from "../Views/Employees";
import ProtectedRouter from "./ProductedRouter";
import Forgotpassword from "../Views/Login/ForgotPassword";
import ResetPassword from "../Views/Login/ResetPassword";
import IndexVisitorLogs from "../Views/VisitorEntry/IndexVisitorLogs";
import NewVisitor from "../Views/VisitorEntry/NewVisitor";
import IndexBlocklist from "../Views/Blocklist/IndexBlocklist";
import Settings from "../Views/Settings";
import { MODULES, ROLE_BY_PERMISSIONS } from "../Constant";
import Forbidden from "../Views/Forbidden/Index";
import ViewVisitor from "../Views/VisitorEntry/Forms/ViewVisitorForm";

const Router = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/forgotpassword" element={<Forgotpassword />} /> */}
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/forbidden" element={<Forbidden />} />
            <Route path="*" element={<Forbidden />} />
          </Route>
          <Route>
            <Route element={<ProtectedRouter isGateway={true} />}>
              <Route element={<Layout />}>
                {/* DASHBOARD */}

                <Route path="/" element={<Dashboard />} />
                {/* EMPLOYEE */}
                <Route
                  element={
                    <ProtectedRouter
                      from="employee"
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.EMPLOYEE].SHOW_EMPLOYEE,
                      ]}
                    />
                  }
                >
                  <Route path="/users" element={<Employees />} />
                </Route>
                {/* BLACK LIST */}
                {/* <Route
                  element={
                    <ProtectedRouter
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.BLACKLIST].SHOW_BLACKLIST,
                      ]}
                    />
                  }
                >
                  <Route path="/blacklist" element={<IndexBlocklist />} />
                </Route> */}
                {/* VISITOR LOGS */}
                <Route
                  element={
                    <ProtectedRouter
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                          .SHOW_VISITOR_LOGS,
                      ]}
                    />
                  }
                >
                  <Route path="/visitor-logs" element={<IndexVisitorLogs />} />
                </Route>
                <Route
                  element={
                    <ProtectedRouter
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                          .SHOW_VISITOR_LOGS,
                      ]}
                    />
                  }
                >
                  <Route
                    path="/visitor-logs/view/:id"
                    element={<ViewVisitor />}
                  />
                </Route>
                {/* VISITOR LOGS -  CREATE / UPDATE */}
                <Route
                  element={
                    <ProtectedRouter
                      type="SOME"
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                          .CREATE_VISITOR_LOGS,
                        ROLE_BY_PERMISSIONS[MODULES.VISITOR_LOGS]
                          .UPDATE_VISITOR_LOGS,
                      ]}
                    />
                  }
                >
                  <Route path="/visitor-logs/:type" element={<NewVisitor />} />
                </Route>
                {/* SETTINGS */}
                <Route
                  element={
                    <ProtectedRouter
                      type="SOME"
                      requiredPermissions={[
                        ROLE_BY_PERMISSIONS[MODULES.MASTER_SETTINGS]
                          .SHOW_MASTER_SETTINGS,
                        ROLE_BY_PERMISSIONS[MODULES.CUSTOM_ROLES]
                          .SHOW_CUSTOM_ROLES,
                        ROLE_BY_PERMISSIONS[MODULES.REMINDERS].SHOW_REMINDERS,
                        ROLE_BY_PERMISSIONS[MODULES.OTHER_SETTINGS]
                          .SHOW_OTHER_SETTINGS,
                      ]}
                    />
                  }
                >
                  <Route path="/settings" element={<Settings />} />
                </Route>
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default Router;
